import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Modal,
  Button,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import NavBar from '../../components/NavBar';
import { TRANSLATION_FILES } from '../../constants/translation';
import Form from './Form';
import { decodeSearch } from '../../utils/url';

export class New extends Component {
  state = { formKey: 0, formLocation: this.props.location, pendingHandoff: null, handoffLoading: false };
  handoffVersion = 0;
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search === this.props.location.search && nextProps.location.pathname === this.props.location.pathname) return;
    this.handoffVersion += 1;
    const previous = decodeSearch(this.state.formLocation.search || '');
    const next = decodeSearch(nextProps.location.search || '');
    // A new SR arrival naming another unit needs a fresh booking and unit loader.
    // Query removal and the form's own unit selector retain the current instance.
    if (Object.prototype.hasOwnProperty.call(next, 'srCode') &&
      (next.unitID !== previous.unitID || next.projectID !== previous.projectID)) {
      if (this.leaveGuard && this.leaveGuard.shouldBlock()) {
        this.setState({ pendingHandoff: { location: nextProps.location, guard: this.leaveGuard, version: this.handoffVersion } });
        return;
      }
      this.setState(({ formKey }) => ({ formKey: formKey + 1, formLocation: nextProps.location, pendingHandoff: null }));
    } else {
      this.setState({ formLocation: nextProps.location, pendingHandoff: null });
    }
  }
  componentWillUnmount() { this.unmounted = true; this.handoffVersion += 1; }
  registerLeaveGuard = (guard) => {
    this.leaveGuard = guard;
    if (this.props.registerLeaveGuard) this.props.registerLeaveGuard(guard);
  }
  cancelHandoff = () => {
    this.handoffVersion += 1;
    this.setState({ pendingHandoff: null });
    this.context.store.dispatch(replace(this.state.formLocation));
  }
  confirmHandoff = async () => {
    const pending = this.state.pendingHandoff;
    if (!pending) return;
    this.setState({ handoffLoading: true });
    try { await pending.guard.onConfirm(); } catch (err) {
      // As with the route leave guard, server expiry remains the release backstop.
    } finally {
      if (!this.unmounted && pending.version === this.handoffVersion) {
        this.setState(({ formKey }) => ({ formKey: formKey + 1, formLocation: pending.location, pendingHandoff: null, handoffLoading: false }));
      } else if (!this.unmounted) {
        this.setState({ handoffLoading: false });
      }
    }
  }
  static propTypes = {
    token: PropTypes.string,
    location: PropTypes.shape({
      hash: PropTypes.string,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    loading: PropTypes.bool,
    onCheck: PropTypes.func,
    registerLeaveGuard: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  handleSubmit = (event) => {
    this.form.handleSubmit(event);
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('New')}
        />
        <Form
          key={this.state.formKey}
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, project) => {
            this.submit(validations, project);
          }}
          onChange={this.handleOnCheck}
          registerLeaveGuard={this.registerLeaveGuard}
          location={this.state.formLocation}
          loading={this.props.loading}
          token={this.props.token}
        />
        {this.state.pendingHandoff && (
          <Modal open closeOnDimmerClick={false} closeOnEscape={false} size="small">
            <Modal.Header>{this.state.pendingHandoff.guard.header()}</Modal.Header>
            <Modal.Content>{this.state.pendingHandoff.guard.message()}</Modal.Content>
            <Modal.Actions>
              <Button disabled={this.state.handoffLoading} onClick={this.cancelHandoff}>{t('Stay', { ns: TRANSLATION_FILES.translation })}</Button>
              <Button primary loading={this.state.handoffLoading} disabled={this.state.handoffLoading} onClick={this.confirmHandoff}>{t('Leave', { ns: TRANSLATION_FILES.translation })}</Button>
            </Modal.Actions>
          </Modal>
        )}
      </Container>
    );
  }
}
export default withTranslation(TRANSLATION_FILES.constants)(New);



// WEBPACK FOOTER //
// ./src/containers/Bookings/New.jsx